import { BoxProps } from "@chakra-ui/react";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TwitterIcon,
  YoutubeIcon,
} from "../../../icons";
import { SocialMediaLinkModel } from "../../../api/models";

export const socialMediaOrder = [
  "linkedin",
  "facebook",
  "instagram",
  "youtube",
  "twitter",
];

export const socialMediaIcons = {
  linkedin: LinkedinIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  youtube: YoutubeIcon,
  twitter: TwitterIcon,
};

export interface SocialLinksProps extends BoxProps {
  links: SocialMediaLinkModel[];
}
